if (!customElements.get('localization-form')) {

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        select: this.querySelector('select')
      };
      this.elements.select.addEventListener('change', (event) => {
        this.handleSelectChange(event);
      });
    }

    handleSelectChange(event) {
      // Set input to the right value when
      if(this.elements.input != this.elements.select.value) {
        const form = this.querySelector('form');
        this.elements.input.value = this.elements.select.value;
        if (form) form.submit();
      }
    }

  }

  customElements.define('localization-form', LocalizationForm);

}